import API_BASE_URL from "../../config";

// export default CommentsPage;
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./CommentsPage.css";

const CommentsPage = ({ videoId, currentUserId, onClose }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const history = useHistory();

  useEffect(() => {
    fetch(`${API_BASE_URL}/comments/${videoId}`)
      .then((res) => res.json())
      .then((data) => {
        // Sort comments by creation date in ascending order so the most recent is at the bottom
        const sortedComments = data.comments.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setComments(sortedComments);
      })
      .catch((error) => console.error("Error fetching comments:", error));
  }, [videoId]);

  const handleAddComment = async () => {
    // Check if the user is logged in
    if (!localStorage.getItem("jwt")) {
      history.push("/signin");
      return;
    }

    if (newComment.trim() === "") {
      console.error("Comment cannot be empty.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        body: JSON.stringify({
          video_id: videoId,
          comment: newComment,
          parent_id: null,
          user_id: currentUserId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error(
          "Failed to add comment:",
          errorData.error || response.statusText
        );
        return;
      }

      const comment = await response.json();
      setComments([...comments, comment]);
      setNewComment("");
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  const formatToEST = (dateString) => {
    const options = {
      timeZone: "America/New_York",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleString("en-US", options);
  };

  useEffect(() => {
    const commentsContainer = document.querySelector(".comments-list");
    commentsContainer.scrollTop = commentsContainer.scrollHeight;
  }, [comments]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".comments-page")) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="comments-page">
      <div className="comments-header">
        <h2>Comments</h2>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="comments-list">
        {comments.map((comment) => (
          <div key={comment.id} className="comment-item">
            <div className="comment-author">
              <img
                src="/image/Capture.jpg"
                alt="User"
                className="comment-profile-image"
              />
              {comment.first_name}
            </div>
            <div className="comment-body">{comment.comment}</div>
            <div className="comment-time">
              {formatToEST(comment.created_at)}
            </div>
          </div>
        ))}
      </div>
      <div className="add-comment">
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a comment..."
        ></textarea>
        <button onClick={handleAddComment} className="submit-comment-button">
          <img
            src="/image/send.png"
            alt="sendcomment"
            className="sendcomment"
          />
        </button>
      </div>
    </div>
  );
};

export default CommentsPage;
